import { auth } from "./config";
import firebase from "firebase/compat/app";
import { LOCAL_STORAGE_KEYS } from "../constants/AppConstants";



export const signInWithGoogle = async (navigate) => {

  console.log("signInWithGoogle -- start of function");
  const provider = new firebase.auth.GoogleAuthProvider();

  // This helps ensure the user picks a meetava.com account
  provider.setCustomParameters({hd: 'meetava.com'});

  try {
    console.log("signInWithGoogle -- about to call signInWithPopup");
    const res = await auth.signInWithPopup(provider);
    const user = res.user;
    const idToken = await user.getIdToken();
    console.log("signInWithGoogle -- got the token -- writing down");

    //window.localStorage.setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, idToken);

    navigate.push(`/users`);
    //return user;
  }
  catch (err) {
    alert(err.message);
  }
};

